import {FC} from "react";

const CalComIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 20,
}) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
    <rect width={20} height={20} rx={2} fill="#242424" />
    <path
      d="M6.36118 13.9884C4.15882 13.9884 2.5 12.2453 2.5 10.0933C2.5 7.93411 4.07412 6.17665 6.36118 6.17665C7.57529 6.17665 8.41527 6.54966 9.07174 7.40329L8.01292 8.28561C7.56823 7.81217 7.03175 7.57545 6.36118 7.57545C4.87176 7.57545 4.05294 8.71601 4.05294 10.0933C4.05294 11.4706 4.9494 12.5896 6.36118 12.5896C7.02468 12.5896 7.58942 12.3529 8.03411 11.8794L9.07881 12.7976C8.45058 13.6154 7.58942 13.9884 6.36118 13.9884Z"
      fill="white"
    />
    <path
      d="M13.6388 8.25662H15.0646V13.8518H13.6388V13.0341C13.3423 13.6151 12.8481 14.0024 11.9023 14.0024C10.3917 14.0024 9.18462 12.6897 9.18462 11.0757C9.18462 9.46174 10.3917 8.14902 11.9023 8.14902C12.8411 8.14902 13.3423 8.53638 13.6388 9.11742V8.25662ZM13.6811 11.0757C13.6811 10.2006 13.0811 9.47609 12.1352 9.47609C11.2246 9.47609 10.6317 10.2077 10.6317 11.0757C10.6317 11.9222 11.2246 12.6754 12.1352 12.6754C13.0741 12.6754 13.6811 11.9437 13.6811 11.0757Z"
      fill="white"
    />
    <path d="M16.0741 5.99707H17.5V13.8447H16.0741V5.99707Z" fill="white" />
  </svg>
);

export default CalComIcon;
